/* Infinity Paintball · motor de cotización compartido por las landings.
   Precios y reglas en un solo lugar: si cambia algo, se cambia aquí. */
(function () {
  const ITEMS = ["Marcadora", "100 bolitas", "Careta", "Chaleco"];
  const C = {
    wa: "18493527597",
    waPretty: "+1 849 352 7597",
    maps: "https://maps.app.goo.gl/zRSoUf12GAh4MirM7",
    site: "https://infinitypaintballrd.com",
    // API de conversiones: webhook de Make que reenvía el Lead a Meta desde el servidor
    capiHook: "https://hook.us2.make.com/z4w9bjrqvge7jkd6dtj3plb7wiyistd3",
    grupo: [
      { id: "basico", name: "Básico", price: 850, min: 2, items: ITEMS, plus: [], line: "Equipo completo y 100 bolitas" },
      { id: "standard", name: "Standard", price: 1200, min: 2, items: ITEMS, plus: ["Piscina"], line: "Equipo, 100 bolitas y piscina" },
      { id: "premium", name: "Premium", price: 1850, min: 6, items: ITEMS, plus: ["Piscina", "Almuerzo típico dominicano"], line: "Equipo, 100 bolitas, piscina y almuerzo" }
    ],
    cumple: [
      { id: "cumple1", name: "Cumple Combo 1", short: "Combo 1", flat: 15900, players: 10, balls: "1,000 bolitas + 100 gratis" },
      { id: "cumple2", name: "Cumple Combo 2", short: "Combo 2", flat: 18900, players: 15, balls: "1,500 bolitas + 100 gratis" }
    ],
    cumpleIncl: ["Snack", "Refresco", "Bizcocho"],
    extra: 850, pool: 300, discFrom: 11, disc: 0.10, min: 2, max: 60,
    // Feriados RD en la fecha en que se disfrutan. Verificar con el calendario oficial.
    holidays: { "2026-11-09": "Constitución", "2026-12-25": "Navidad", "2027-01-01": "Año Nuevo", "2027-01-04": "Reyes", "2027-01-21": "Altagracia", "2027-01-25": "Duarte", "2027-02-27": "Independencia", "2027-03-26": "Viernes Santo" },
    slots: ["10 AM – 12 PM", "12 – 2 PM", "2 – 4 PM", "4 – 6 PM"]
  };

  const rd = v => "RD$" + Math.round(v).toLocaleString("en-US");
  const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  const DIA = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
  const DIA_L = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
  const iso = d => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
  const find = id => C.grupo.concat(C.cumple).find(x => x.id === id);

  /* s = { combo, n, pool }  — n cuenta a TODOS los que juegan (en cumpleaños, cumpleañero incluido) */
  function quote(s) {
    const c = find(s.combo);
    if (c.flat) {
      const base = c.players + 1;
      const people = Math.max(s.n, base);
      const extra = people - base;
      const extraCost = extra * C.extra;
      const poolCost = s.pool ? people * C.pool : 0;
      const total = c.flat + extraCost + poolCost;
      const lines = [[`${c.short}: ${c.players} jugadores + cumpleañero`, c.flat]];
      if (extra) lines.push([`${extra} jugador${extra > 1 ? "es" : ""} extra × ${rd(C.extra)}`, extraCost]);
      if (s.pool) lines.push([`Piscina: ${people} × ${rd(C.pool)}`, poolCost]);
      return { c, kind: "cumple", people, extra, total, dep: Math.ceil(total / 2), per: total / people, lines, disc: 0, under: s.n < base, spare: Math.max(0, base - s.n), blocked: false,
        includes: `${c.balls}, snack, refresco y bizcocho` };
    }
    const sub = c.price * s.n;
    const disc = s.n >= C.discFrom ? sub * C.disc : 0;
    const total = sub - disc;
    const lines = [[`${c.name}: ${s.n} × ${rd(c.price)}`, sub]];
    if (disc) lines.push(["Descuento de grupo (10%)", -disc]);
    return { c, kind: "grupo", people: s.n, extra: 0, total, dep: Math.ceil(total / 2), per: total / s.n, lines, disc, under: false,
      blocked: s.n < c.min, includes: c.items.concat(c.plus).join(", ").toLowerCase() };
  }

  /* Opciones ordenadas para un tamaño de grupo, con la recomendación honesta: la más barata que cumple lo pedido */
  function options(mode, n, pool) {
    let list;
    if (mode === "cumple") {
      list = C.cumple.map(c => ({ combo: c.id, q: quote({ combo: c.id, n, pool }) }));
      if (n < 11) {

        const std = { combo: "standard", q: quote({ combo: "standard", n, pool: false }) };
        std.tag = "Más económico para " + n;
        std.warn = "No incluye bizcocho, snack ni refresco";
        list.push(std);
      } else {
        const best = list.reduce((a, b) => (b.q.total < a.q.total ? b : a));
        best.tag = "Mejor precio para " + n;
      }
    } else {
      list = C.grupo.map(c => ({ combo: c.id, q: quote({ combo: c.id, n, pool: false }) }));
      const std = list.find(o => o.combo === "standard");
      std.tag = "El que más eligen";
      const prem = list.find(o => o.combo === "premium");
      if (!prem.q.blocked) prem.tag = prem.tag || "Día completo";
    }
    return list;
  }

  function openDays(count) {
    const out = [], t = new Date(); t.setHours(0, 0, 0, 0);
    for (let i = 0; out.length < count && i < 150; i++) {
      const d = new Date(t); d.setDate(t.getDate() + i);
      const k = iso(d), wd = d.getDay();
      if (wd === 5 || wd === 6 || wd === 0 || C.holidays[k])
        out.push({ iso: k, dow: DIA[wd], day: d.getDate(), mon: MES[d.getMonth()], holiday: C.holidays[k] || "", today: i === 0, soon: i < 7 });
    }
    return out;
  }
  function dateLabel(k) {
    const [y, m, d] = k.split("-").map(Number), dt = new Date(y, m - 1, d);
    return `${DIA_L[dt.getDay()]} ${d} de ${MES[m - 1]}${C.holidays[k] ? " (feriado)" : ""}`;
  }

  const ticket = "INF-" + Math.random().toString(36).slice(2, 6).toUpperCase();

  const cap = t => t.charAt(0).toUpperCase() + t.slice(1);

  /* Mensaje para mandar al chat del grupo: corto, claro y con ganas de jugar */
  function shareMessage(s) {
    const q = quote(s), cumple = q.kind === "cumple";
    const inc = cumple ? q.includes
      : ["equipo de protección", "marcadora", "100 bolitas"].concat(q.c.plus.map(x => x.toLowerCase())).join(", ").replace(/, ([^,]*)$/, " y $1");
    const L = [
      cumple ? "🎂🔥 ¡Celebramos el cumpleaños con un PASADÍA de paintball!" : "🔥 ¡Nos vamos de PASADÍA! 🎯",
      "",
      "📍 Infinity Paintball · Hato Mayor del Rey"
    ];
    if (s.date) L.push(`📅 ${cap(dateLabel(s.date))}${s.slot ? " · llegada " + s.slot : ""}`);
    L.push(`👥 ${q.people} jugadores · ${cumple ? q.c.name : "Combo " + q.c.name}`);
    L.push(`🎯 Incluye ${inc}`);
    L.push("⏱️ Sin límite de tiempo: jugamos hasta la última bolita");
    L.push(`💰 Sale a ${rd(q.per)} por cabeza (total ${rd(q.total)})`);
    if (s.pool && cumple) L.push("🏊 Después, piscina");
    L.push("", "¿Quién se apunta? Responde con un 🙋 y cuadramos.");
    if (C.site) L.push("", "Mira los combos: " + C.site);
    return L.join("\n");
  }

  function message(s, o = {}) {
    if (o.share) return shareMessage(s);
    const q = quote(s), cumple = q.kind === "cumple";
    const head = o.share
      ? (cumple ? "¡Vamos a celebrar el cumpleaños jugando paintball! 🎂🎯 Mira la cotización:" : "¿Vamos a jugar paintball? 🎯 Mira la cotización:")
      : (cumple ? "¡Hola Infinity! Quiero reservar un cumpleaños 🎂" : "¡Hola Infinity! Quiero reservar 🎯");
    const L = [head];
    if (o.occasion && !cumple) L.push(`• Plan: ${o.occasion}`);
    L.push(cumple ? `• ${q.c.name}: ${q.c.players} jugadores + cumpleañero` : `• Combo: ${q.c.name} (${rd(q.c.price)} c/u)`);
    L.push(`• Jugadores: ${q.people}`);
    if (cumple) L.push(`• Incluye: ${q.includes}`);
    if (q.extra) L.push(`• Jugadores extra: ${q.extra} × ${rd(C.extra)}`);
    if (s.pool && cumple) L.push(`• Piscina: ${q.people} × ${rd(C.pool)}`);
    if (q.disc) L.push(`• Descuento de grupo: −${rd(q.disc)}`);
    if (s.date) L.push(`• Día: ${dateLabel(s.date)}`);
    if (s.slot) L.push(`• Llegada: ${s.slot}`);
    L.push(`• Total: ${rd(q.total)} (separo con ${rd(q.dep)})`);
    if (!o.share) {
      if (o.bday && cumple) L.push(`Cumpleañero/a: ${o.bday}`);
      if (o.name) L.push(`Nombre: ${o.name}`);
      L.push(`Cotización #${ticket}`);
    } else L.push("", "Es en Hato Mayor del Rey y se juega sin límite de tiempo. ¿Quién se apunta?");
    return L.join("\n");
  }
  // api.whatsapp.com directo: wa.me redirige y daña los emojis de 4 bytes (salen como signos de interrogación)
  const waUrl = (text, toBusiness = true) => "https://api.whatsapp.com/send?" + (toBusiness ? `phone=${C.wa}&` : "") + "text=" + encodeURIComponent(text);

  const normPhone = v => { let d = String(v).replace(/\D/g, ""); if (d.length === 11 && d[0] === "1") d = d.slice(1); return d; };
  const validPhone = v => /^(809|829|849)\d{7}$/.test(normPhone(v));

  /* fbclid del anuncio: se guarda al entrar para armar el fbc aunque la persona navegue */
  const FBCLID = (() => {
    try {
      const id = new URLSearchParams(location.search).get("fbclid");
      if (id) { const v = `fb.1.${Date.now()}.${id}`; localStorage.setItem("inf_fbc", v); return v; }
      return localStorage.getItem("inf_fbc") || "";
    } catch (e) { return ""; }
  })();
  const cookie = n => { try { const m = document.cookie.match("(?:^|; )" + n + "=([^;]*)"); return m ? decodeURIComponent(m[1]) : ""; } catch (e) { return ""; } };
  async function sha256(t) {
    const b = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(t));
    return [...new Uint8Array(b)].map(x => x.toString(16).padStart(2, "0")).join("");
  }

  /* Lead por servidor (API de conversiones). Teléfono y nombre salen ya cifrados. Mismo event_id que el Pixel para no contar doble */
  async function sendCapi(p) {
    if (!C.capiHook || !window.crypto || !crypto.subtle) return;
    try {
      const digits = normPhone(p.phone || "");
      const ud = { client_user_agent: navigator.userAgent, country: [await sha256("do")] };
      if (digits) ud.ph = [await sha256("1" + digits)];
      const fn = (p.name || "").trim().split(/\s+/)[0].toLowerCase();
      if (fn) ud.fn = [await sha256(fn)];
      const fbc = cookie("_fbc") || FBCLID, fbp = cookie("_fbp");
      if (fbc) ud.fbc = fbc;
      if (fbp) ud.fbp = fbp;
      const event = {
        event_name: "Lead", event_time: Math.floor(Date.now() / 1000), event_id: p.ticket,
        action_source: "website", event_source_url: location.origin + location.pathname, user_data: ud,
        custom_data: { currency: "DOP", value: p.value, content_name: p.combo, content_category: p.occasion || p.mode, num_items: p.people }
      };
      const body = new URLSearchParams({ event: JSON.stringify(event) });
      if (!(navigator.sendBeacon && navigator.sendBeacon(C.capiHook, body)))
        fetch(C.capiHook, { method: "POST", body, mode: "no-cors", keepalive: true });
    } catch (e) {}
  }

  /* Seguimiento: en Shopify llega al Custom Pixel por Shopify.analytics.publish, que lo pasa a Meta */
  const fired = new Set();
  function track(name, data = {}, once = true) {
    if (once && fired.has(name)) return;
    fired.add(name);
    const payload = Object.assign({}, data, { ticket, currency: "DOP" });
    try { window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish("infinity_" + name, payload); } catch (e) {}
    try { window.fbq && window.fbq("trackCustom", name, payload); } catch (e) {}
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload));
    if (name === "Lead") sendCapi(payload);
  }

  /* Abre WhatsApp; si el navegador lo bloquea, la página muestra su propio botón de respaldo */
  function openWA(url) { const w = window.open(url, "_blank", "noopener"); return !!w; }

  /* Número que sube o baja suave */
  function roll(el, to, fmt = rd) {
    const from = +(el.dataset.v || 0), t0 = performance.now();
    const dur = matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 420;
    el.dataset.v = to;
    const step = t => {
      const p = dur ? Math.min(1, (t - t0) / dur) : 1, e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(from + (to - from) * e);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  window.INF = { C, rd, quote, shareMessage, options, openDays, dateLabel, message, waUrl, normPhone, validPhone, track, ticket, openWA, roll, find };
})();
